import React from 'react'

import { getPositionName } from 'services/Utilities'
import { Badge } from 'ui'

const UserOccupations = ({ occupations, withBadge }) => {
  if (!occupations) return null
  const { primary, secondary } = occupations

  if (withBadge)
    return (
      <>
        {primary && primary !== 'none' ? (
          <Badge variant="secondary" className="mr-1">
            {getPositionName(primary)}
          </Badge>
        ) : null}
        {secondary && secondary !== 'none' ? (
          <Badge variant="light" className=" mr-1">
            {getPositionName(secondary)}
          </Badge>
        ) : null}
      </>
    )
  return (
    <>
      <span className="mr-1">{getPositionName(primary)}</span>
      {getPositionName(secondary)}
    </>
  )
}

export default UserOccupations
